module.exports = __webpack_public_path__ + "img/qrcode.6a06223b.png";